import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;



class SubCategory {
  create = async (category: any) => {
    await axios.post<any>(`${API_URL}sub-category`, category)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  
  };

  edit = async (category: any, code: any) => {
    await axios.put<any>(`${API_URL}sub-category/${code}`, category)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}sub-category/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.subCategories;
  };

  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}sub-category`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.subCategories;
  };
}

export default new SubCategory();
